import React from 'react'
import { Stack, type StackProps } from '@mantine/core'

export type AppStackProps = StackProps;

export default function AppStack (props: AppStackProps) {
  return <Stack spacing="sm" {...props} />
}
